<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="form-group pt-2">
    <input type="checkbox" id="enabled" formControlName="enabled" />
    <label class="ps-1" for="enabled">
      {{ 'Settings::VoiceMorphing.Settings.Label' | abpLocalization }}
    </label>
  </div>
  <div>
    <small class="form-text text-muted">
      {{ 'Settings::VoiceMorphing.Settings.Description' | abpLocalization }}
    </small>
  </div>

  <button type="button" type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
